import script from "./LayoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutView.vue?vue&type=script&setup=true&lang=js"

import "./LayoutView.vue?vue&type=style&index=0&id=39128727&lang=css"

const __exports__ = script;

export default __exports__